import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {OverlayComponent} from './overlay.component';
import {OverlayService} from './overlay.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        OverlayComponent
    ],
    providers: [
        OverlayService
    ]
})
export class OverlayModule {}
